import { CampaignStory } from "../../types"
import ChatCard from '../ChatCard'
import CampaignCard from "../campaign-selection/CampaignCard"

type Props = {
  campaignStories: CampaignStory[],
  event_id: number,
  event_name: string,
}

const CreateThemeResult = ({ campaignStories, event_name, event_id }: Props) => {

  return (
    <ChatCard user="assistant" key="first">
      <div className="w-full flex flex-col gap-2">
        <h2 className="w-full text-lg font-montserrat font-medium">{event_name}</h2>
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 md:grid-rows-3 gap-3">
          {campaignStories && campaignStories.map(item => (
            <CampaignCard
              type="create"
              id={item.sequence_order}
              data={item} event_id={event_id} key={item.story_id} onThemeSelect={() => {/* story selection */ }} onReasoning={() => { }} />
          ))}
        </div>
      </div>
    </ChatCard>
  )
}

export default CreateThemeResult;
